"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleOptionButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _menu = require("../../utils/menu");
var _OptionButton = require("./OptionButton");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SimpleOptionButtonBase = (props, ref) => {
  const {
    size = 'small',
    classNames,
    tooltip,
    anchorPosition,
    options,
    optionsVariant,
    allowSearch,
    selectedKeys,
    onOptionSelect,
    onButtonClick,
    onMenuOpen,
    onMenuClose,
    resolveLabel,
    resolveSecondaryLabel,
    children,
    menuSize = 'small',
    menuVirtualization,
    header,
    footer,
    menuClassNames,
    showLabelTooltip,
    clickAwayRef,
    allowWrap = false,
    ...buttonProps
  } = props;
  const [optionButtonSelectedKeys, setOptionButtonSelectedKeys] = React.useState(selectedKeys);
  React.useEffect(() => {
    setOptionButtonSelectedKeys(selectedKeys);
  }, [selectedKeys]);
  const handleOptionChange = (selectedOption, e) => {
    e?.stopPropagation();
    let newSelectedKeys = [selectedOption.key];
    if (optionsVariant === 'checkbox') {
      newSelectedKeys = (0, _menu.getSelectedKeysFromSelectedOption)(selectedOption, optionButtonSelectedKeys);
    } else {
      newSelectedKeys = [selectedOption.key];
    }
    setOptionButtonSelectedKeys(newSelectedKeys);
    setTimeout(() => {
      onOptionSelect?.(selectedOption, e);
    });
  };
  React.useImperativeHandle(ref, () => ({
    selectedKeys: optionButtonSelectedKeys
  }));
  return /*#__PURE__*/React.createElement(_OptionButton.OptionButton, _extends({}, buttonProps, {
    tooltip: tooltip,
    onButtonClick: onButtonClick,
    anchorPosition: anchorPosition,
    classNames: classNames,
    size: size,
    onOptionSelect: handleOptionChange,
    onMenuOpen: onMenuOpen,
    onMenuClose: onMenuClose,
    clickAwayRef: clickAwayRef,
    menu: {
      isFluid: false,
      options,
      selectedKeys: optionButtonSelectedKeys,
      optionsVariant,
      allowSearch,
      resolveLabel,
      resolveSecondaryLabel,
      size: menuSize,
      virtualization: menuVirtualization,
      header,
      footer,
      classNames: menuClassNames,
      showLabelTooltip,
      allowWrap
    }
  }), children);
};
const SimpleOptionButton = /*#__PURE__*/React.forwardRef(SimpleOptionButtonBase);
exports.SimpleOptionButton = SimpleOptionButton;